import { render, staticRenderFns } from "./OilResetButton.vue?vue&type=template&id=a6f34d74&scoped=true"
import script from "./OilResetButton.vue?vue&type=script&lang=js"
export * from "./OilResetButton.vue?vue&type=script&lang=js"
import style0 from "./OilResetButton.vue?vue&type=style&index=0&id=a6f34d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f34d74",
  null
  
)

export default component.exports